import { Component } from '@angular/core';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { VisualsService } from '@core/Abstract/visuals.service';


@Component({
    selector: 'app-footer',
    template: `
    <footer class="footer text-center">
        Copyright &copy; {{currentYear}} <a href="{{link}}" target="_blank" class>{{linkVisual}}</a>
    </footer>
    `
})
export class FooterComponent {

    private link: string = '';
    private linkVisual: string = '';
    private currentYear = new Date().getFullYear();

    protected genericVis = {};


    constructor(private securityService: SecurityService,
        private eventsEmitterService: EventsEmitterService,
        private logger: LogService,
        private visualsService: VisualsService) {

        this.loadVisuals();
        this.getFooterLink();

        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.loadVisuals();
            }
        );
    }

    ngOnInit(): void { }

    ngOnDestroy() { }

    protected getFooterLink() {
        this.visualsService.getParam('ADM_FOOTER_LINK').subscribe(
            data => {
                this.link = data.paramValStr;
            }
        );
        this.visualsService.getParam('ADM_FOOTER_VISUAL').subscribe(
            data => {
                this.linkVisual = data.paramValStr;
            }
        );
    }

    protected loadVisuals(): void {
        this.genericVis = this.visualsService.getFromStorageAsJSON('visualsArray') ? this.visualsService.getFromStorageAsJSON('visualsArray')['generic'] : {};
    }

}
